<template>
<div class="main mt15 p34">
	<div class="my-title">{{info.productName||''}}</div>
	<!-- 企业雇主责任险 -->
	<div v-if="type!='common'">
		<!-- 订单信息 -->
		<OrderBasicInfo :info="info" v-if="pageType=='order'"/>
		<!-- 保单信息 -->
		<PolicyBasicInfo :info="info" v-if="pageType=='policy'"/>
		<template  v-if="info.productCode=='GSCGZZRX'||info.productCode=='GSCGZZRXPC'||info.productCode=='GSCGZZRXPCUPD'||info.productCode=='GSCGZZRXPCUPDA'">
			<!-- 申请人信息 -->
			<ApplicantInfoGs :info="info" title="投保企业信息"/>
			<!-- 参加人员信息  -->
			<RecognizeInfoGs :info="info" :from="pageType" />
			<!-- 开票信息 -->
			<Invoice :info="info" ref="invoice" v-if="orderType==1" />
			<InvoiceInfo :info="info" v-else />
		</template>
		<template v-else>
			<!-- 申请人信息 -->
			<ApplicantInfo :info="info" title="投保企业信息"/>
			<!-- 参加人员信息  -->
			<RecognizeInfo :info="info" :from="pageType" />
			<!-- 开票信息 -->
			<InvoiceInfo :info="info" />
		</template>
	</div>


	<!-- 通用框架 -->
	<div v-if="type=='common'">
		<!-- 订单信息 -->
		<OrderBasicInfoForCommon :info="info" v-if="pageType=='order'"/>

		<!-- 保单信息 -->
		<PolicyBasicInfoForCommon :info="info" v-if="pageType=='policy'"/>

		<!-- 参加人员信息货车雇主责任险按人 -->
		<RecognizeInfoForTruckPerosn :info="info" :from="pageType" title="参加人员信息" v-if="info.productCode=='TRUCK_EMPLOYERS_LIABILITY_INSURANCE_WITH_PEOPLE'" />
		<!-- 参加人员信息货车雇主责任险按车 -->
		<RecognizeInfoForTruckCar :info="info" :from="pageType" title="参加人员信息" v-if="info.productCode=='TRUCK_EMPLOYERS_LIABILITY_INSURANCE_WITH_TRUCK'" />

		<!-- 申请人信息通用框架 -->
		<ApplicantInfoForCommon :info="info.applicantInfo" :upload-file-list="applicantUploadFileList"/>

		<!-- 开票信息 -->
		<InvoiceInfoForCommon :info="info.invoiceInfo" v-if="pageType=='order'" :type="info.applicantInfo?info.applicantInfo.identityType:''"/>
	</div>
	<div class="mt20 center" v-if="orderType==1">
        <p class="mt10">
            <Button type="primary" @click="toPay" :loading="loading">提交</Button>
        </p>
    </div>

</div>
</template>
<script>
import OrderBasicInfo from '../common/OrderBasicInfo'
import OrderBasicInfoForCommon from '../common/OrderBasicInfoForCommon'
import PolicyBasicInfo from '../common/PolicyBasicInfo'
import PolicyBasicInfoForCommon from '../common/PolicyBasicInfoForCommon'
import ApplicantInfo from '../../companyGroupEmployer/common/ApplicantInfo'
import ApplicantInfoGs from '../../companyGroupEmployerGS/common/ApplicantInfo'
import ApplicantInfoForCommon from '../../common/ApplicantInfo'
import InvoiceInfo from '../../companyGroupEmployer/common/InvoiceInfo'
import Invoice from '../../companyGroupEmployerGS/common/Invoice'
import InvoiceInfoForCommon from '../../common/InvoiceInfo'
import {applicantUploadFileMap} from '@/pages/haierProduct/common/dictionary'
import RecognizeInfo from '../../companyGroupEmployer/RecognizeInfo'
import RecognizeInfoGs from '../../companyGroupEmployerGS/RecognizeInfo'
import RecognizeInfoForTruckPerosn from '../../truckEmployer/person/RecognizeInfo'
import RecognizeInfoForTruckCar from '../../truckEmployer/car/RecognizeInfo'
export default {
	components:{ 
		OrderBasicInfo,
		OrderBasicInfoForCommon,
		PolicyBasicInfo,
		PolicyBasicInfoForCommon,
		ApplicantInfo,
		ApplicantInfoGs,
		ApplicantInfoForCommon,
		InvoiceInfo,
		InvoiceInfoForCommon,
		RecognizeInfo,
		RecognizeInfoGs,
		RecognizeInfoForTruckPerosn,
		RecognizeInfoForTruckCar,
		Invoice
	},
	data () {
		return {
			info:{},
			id:this.$route.params.id,
			pageType:this.$route.name.split('-')[1], // order订单详情，policy保单详情
			type:this.$route.params.type||'',
			orderType:this.$route.query.orderType||'', // 国寿财允许编辑待支付的订单
			loading:false,
		}
	},
	computed:{
		applicantUploadFileList(){
			if(this.type=='common'&&this.info){
				let list=applicantUploadFileMap[this.info.productCode]
				if(list){
					return list.filter(item=>{
						return item.identityType==this.info.applicantInfo.identityType
					})
				}
			}
			return []
		},
	},
	created () {
		if(this.type=='common'){
			this.getCommonInfo();
		}else{
			this.getInfo();
		}
	},
	methods:{
		async toPay () {
			let res = await this.$refs.invoice.val()
			if (!res) return
			if (this.info.insurancePolicyUrl&&this.info.insurancePolicyUrl.length>0){}else{
				this.alert('请上传投保单')
				return
			}
			let obj = {
				insurancePolicyUrl:this.info.insurancePolicyUrl,
				businessLicenseUrl:this.info.businessLicenseUrl,
				invoiceAccount:this.info.invoiceAccount,
				invoiceAddress:this.info.invoiceAddress,
				invoiceBank:this.info.invoiceBank,
				invoicePhone:this.info.invoicePhone,
				invoiceType:this.info.invoiceType,
				orderNo:this.info.orderNo,
				postAddress:this.info.postAddress,
				correctUrl:this.info.correctUrl,
				email:this.info.email,
				invoiceName: this.info.invoiceName,
				invoiceFaxNo: this.info.invoiceFaxNo,
			}
            if (this.info.correctUrls&&this.info.correctUrls.length>0){
                let urlList = []
                this.info.correctUrls.forEach(item=>{
                    urlList.push(item.correctUrl)
                })
                obj.correctUrl = urlList.join(",")
            }
            // obj.correctUrl = 'http://p-file.haierbx.net/pcWeb/1662172547781PYDeYjbCa5E853tC.png'
			if (obj.invoiceType)obj.invoiceType=Number(obj.invoiceType)
			await this.$axios.post('/employerLiability/updateOrderInfo.json',obj)
			// location.href = `/haierProduct.html#/my/order-detail/${this.info.orderNo}`
			window.location.href = `/haierProduct.html#/my/order`
		},
		// updateOrderInfo
		// 通用框架获取订单保单详情
		getCommonInfo(){
			if(this.pageType=='order'){
				// this.$axios.post('/broker/employerLiability/detail',{
				this.$axios.post('/broker/order/detail',{
					orderNo:this.id
				}).then(res=>{
					this.info=res;
					this.info.applicantInfo=res.applicantList&&res.applicantList.length>0?res.applicantList[0]:{}
					if(res.insuranceEndorseId){
						this.getEditInfo(res.insuranceEndorseId)
					}else{
						this.getApplicationInfo(res.insuranceApplicationId)
					}
				});
			}else{
				this.getPolicyInfo(this.id)
			}
		},
		// 获取投保单信息
		getApplicationInfo(id){
			// 货车雇主责任险去掉脱敏
			let url = ''
			if(this.info.productCode=='TRUCK_EMPLOYERS_LIABILITY_INSURANCE_WITH_PEOPLE'){
				url = '/broker/insurance/application/detail.dst'
			} else {
				url = '/broker/insurance/application/detail'
			}
			this.$axios.post(url,{
				applicationId:id
			}).then(res=>{
				this.info={
					...this.info,
					...res
				}
			});
		},
		// 获取批改单信息
		getEditInfo(id){
			let url = ''
			if(this.info.productCode=='TRUCK_EMPLOYERS_LIABILITY_INSURANCE_WITH_PEOPLE'){
				url = '/broker/insurance/endorse/detail.dst'
			} else {
				url = '/broker/insurance/endorse/detail'
			}
			this.$axios.get(url,{
				insuranceEndorseId:id
			}).then(res=>{
				this.info={
					...this.info,
					...res
				}
				this.getPolicyInfo(this.info.insurancePolicyId)
			});
		},
		// 获取保单信息
		getPolicyInfo(id){
			this.$axios.get('/broker/insurance/policy/detail',{
				insurancePolicyId:id
			}).then(res=>{
				// 货车雇主责任险去掉脱敏
				if(res.productCode=='TRUCK_EMPLOYERS_LIABILITY_INSURANCE_WITH_PEOPLE'){
					this.$axios.get('/broker/insurance/policy/detail.dst',{
						insurancePolicyId:id
					}).then(item=>{
						this.info={
							...item,
							...this.info,
						}
					})
				} else {
					this.info={
						...res,
						...this.info,
					}
				}
				this.info.applicantInfo=this.info.applicantList&&this.info.applicantList.length>0?this.info.applicantList[0]:{}
			});
		},
		/*企业雇主责任险获取订单信息*/
		getInfo () {
			let form={}
			form[this.pageType=='order'?'orderNo':'policyId']=this.id
			this.$axios.post('/employerLiability/getDetailInfo.json',form).then(res=>{
				this.info=res
				if(res.list&&res.list.length>0){
					this.info.subjoinAllDay=res.list[0].subjoinAllDay
					this.info.subjoinOwnMedicine=res.list[0].subjoinOwnMedicine
					this.info.subjoinProportionAdj=res.list[0].subjoinProportionAdj
				}
				console.log(this.info)
			});
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/order/Detail.vue